var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlimitedFurniture = function SvgUnlimitedFurniture(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "#D8D8FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5207)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.4082,
    cy: 88.6735,
    r: 5.61224,
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.2347,
    cy: 66.7857,
    r: 16.2755,
    fill: "#FF5E6D",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7015 98.7177L60.2749 100.425C60.1159 101.061 60.256 101.721 60.6593 102.238C61.0626 102.754 61.6698 103.051 62.3247 103.051C63.2957 103.051 64.1391 102.392 64.3744 101.45L65.0526 98.7392H61.2576C61.0707 98.7392 60.8848 98.732 60.7015 98.7177V98.7177Z",
    fill: "#FC7790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8687 98.7177C94.6855 98.732 94.4995 98.7392 94.3127 98.7392H90.5186L91.1958 101.45C91.4312 102.392 92.2746 103.051 93.2456 103.051C93.9004 103.051 94.5076 102.754 94.9109 102.238C95.3142 101.721 95.4543 101.061 95.2954 100.425L94.8687 98.7177Z",
    fill: "#FC7790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1918 78.6367C61.4778 78.8262 63.4045 80.5185 63.8608 82.7982L64.9666 88.3278C65.0905 88.9475 65.6393 89.3976 66.2717 89.3976H89.2988C89.9312 89.3976 90.48 88.9475 90.604 88.3278L91.7097 82.7982C92.1337 80.6793 93.8286 79.0679 95.9009 78.6987L96.0814 77.6891C96.3904 75.9564 95.9197 74.1887 94.7898 72.8386C93.6598 71.4886 92.0016 70.7143 90.2411 70.7143H64.8327C63.0327 70.7143 61.3512 71.5173 60.2194 72.9168C59.0876 74.3171 58.6547 76.1297 59.0319 77.8894L59.1918 78.6367Z",
    fill: "url(#paint0_linear_1112_5207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0206 79.0384C74.236 79.0384 74.4466 79.1022 74.6258 79.2217C74.805 79.3412 74.9449 79.511 75.0277 79.7099C75.1106 79.9087 75.1327 80.1276 75.0914 80.339C75.0501 80.5504 74.9471 80.7448 74.7955 80.8978C74.6438 81.0508 74.4503 81.1554 74.2393 81.1986C74.0282 81.2418 73.8091 81.2215 73.6096 81.1404C73.41 81.0593 73.239 80.9209 73.1179 80.7428C72.9969 80.5646 72.9313 80.3546 72.9294 80.1392C72.9281 79.9951 72.9554 79.8522 73.0097 79.7187C73.064 79.5852 73.1441 79.4638 73.2456 79.3614C73.347 79.2591 73.4678 79.1778 73.6008 79.1224C73.7338 79.067 73.8765 79.0384 74.0206 79.0384V79.0384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3947 79.0384C78.6101 79.0384 78.8207 79.1022 78.9999 79.2217C79.1792 79.3412 79.319 79.511 79.4019 79.7099C79.4847 79.9087 79.5069 80.1276 79.4656 80.339C79.4242 80.5504 79.3213 80.7448 79.1696 80.8978C79.018 81.0508 78.8244 81.1554 78.6134 81.1986C78.4024 81.2418 78.1833 81.2215 77.9837 81.1404C77.7842 81.0593 77.6131 80.9209 77.4921 80.7428C77.371 80.5646 77.3054 80.3546 77.3036 80.1392C77.3023 79.9951 77.3296 79.8522 77.3839 79.7187C77.4381 79.5852 77.5183 79.4638 77.6197 79.3614C77.7212 79.2591 77.8419 79.1778 77.9749 79.1224C78.1079 79.067 78.2506 79.0384 78.3947 79.0384V79.0384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.769 79.0384C82.5536 79.0384 82.343 79.1022 82.1638 79.2217C81.9845 79.3412 81.8447 79.511 81.7618 79.7099C81.679 79.9087 81.6568 80.1276 81.6981 80.339C81.7395 80.5504 81.8424 80.7448 81.9941 80.8978C82.1457 81.0508 82.3393 81.1554 82.5503 81.1986C82.7613 81.2418 82.9804 81.2215 83.18 81.1404C83.3795 81.0593 83.5506 80.9209 83.6716 80.7428C83.7927 80.5646 83.8583 80.3546 83.8601 80.1392C83.8614 79.9951 83.8341 79.8522 83.7798 79.7187C83.7256 79.5852 83.6454 79.4638 83.544 79.3614C83.4425 79.2591 83.3218 79.1778 83.1888 79.1224C83.0558 79.067 82.9131 79.0384 82.769 79.0384V79.0384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5554 81.2478C98.8466 80.4904 97.8452 80.0559 96.8078 80.0559C96.3967 80.0559 95.9984 80.124 95.6239 80.2489L95.6241 80.2481C94.3629 80.6611 93.3703 81.7756 93.1186 83.0803L92.0128 88.6094C91.7549 89.8987 90.6134 90.8346 89.2984 90.8346H66.2718C64.9569 90.8346 63.8153 89.8988 63.5575 88.6094L62.4516 83.0803C62.1743 81.624 60.9663 80.4163 59.5123 80.1322L59.5124 80.1326C58.2534 79.8655 56.8898 80.3036 56.0149 81.2478C55.3062 82.0054 54.9393 83.0334 55.0082 84.0685L55.5089 91.578C55.5221 94.6691 57.9879 97.1908 61.0568 97.2969L61.0564 97.2984C61.1229 97.3011 61.1902 97.302 61.2576 97.302H65.4119H90.1592H94.3126C94.38 97.302 94.4474 97.3011 94.5138 97.2984L94.5135 97.2969C97.5823 97.1908 100.048 94.6691 100.061 91.578L100.562 84.0685C100.631 83.0334 100.264 82.0053 99.5554 81.2478V81.2478Z",
    fill: "url(#paint1_linear_1112_5207)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5207",
    x1: 96.1742,
    y1: 70.7143,
    x2: 58.8987,
    y2: 70.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5207",
    x1: 100.57,
    y1: 80.0553,
    x2: 55,
    y2: 80.0553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlimitedFurniture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlimited-furniture.7a09e405df5fc3cd4cdf7795f1ae3e13.svg";